import { APP_PERMISSIONS } from '@exam-center/permission';
import { useHasPermission } from '@shared/permissions';

export function useGetReviewerPermissions() {
  // ------ View Access ------

  const hasSupervisorViewPermission = useHasPermission(
    APP_PERMISSIONS.ADMIN_PROCTOR_MANAGEMENT.PROCTOR_REQUEST.VIEW,
  );
  const hasFirstTierReviewerViewPermission = useHasPermission(
    APP_PERMISSIONS.ADMIN_PROCTOR_MANAGEMENT.PROCTOR_REQUEST_FIRST_TIER_REVIEW.VIEW,
  );
  const hasSecondTierReviewerViewPermission = useHasPermission(
    APP_PERMISSIONS.ADMIN_PROCTOR_MANAGEMENT.PROCTOR_REQUEST_SECOND_TIER_REVIEW.VIEW,
  );

  // ------ Update Access ------
  const hasSupervisorUpdatePermission = useHasPermission(
    APP_PERMISSIONS.ADMIN_PROCTOR_MANAGEMENT.PROCTOR_REQUEST.UPDATE,
  );
  const hasFirstTierReviewerUpdatePermission = useHasPermission(
    APP_PERMISSIONS.ADMIN_PROCTOR_MANAGEMENT.PROCTOR_REQUEST_FIRST_TIER_REVIEW.UPDATE,
  );
  const hasSecondTierReviewerUpdatePermission = useHasPermission(
    APP_PERMISSIONS.ADMIN_PROCTOR_MANAGEMENT.PROCTOR_REQUEST_SECOND_TIER_REVIEW.UPDATE,
  );

  return {
    view: {
      supervisor: hasSupervisorViewPermission,
      firstTierReviewer: hasFirstTierReviewerViewPermission,
      secondTierReviewer: hasSecondTierReviewerViewPermission,
    },
    update: {
      supervisor: hasSupervisorUpdatePermission,
      firstTierReviewer: hasFirstTierReviewerUpdatePermission,
      secondTierReviewer: hasSecondTierReviewerUpdatePermission,
    },
  };
}
